/**
 * Rubbl's fillable credit application. The marketplace serves the file from
 * `Rubbl.Web.Website/src/assets/documents`, so these links stay on our site
 * and the browser downloads the PDF instead of opening a credit-provider site.
 */
export const CREDIT_APPLICATION_PATH = "/assets/documents/Rubbl-Credit-Application.pdf";

/** Filename suggested when the browser saves the application. */
export const CREDIT_APPLICATION_FILE_NAME = "Rubbl_Credit_Application.pdf";
